// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"fb67a15e","248":"90f1e6ba","264":"33854921","480":"5798038e","524":"c4ae21ab","648":"dc894e02","832":"565b85ed"}[chunkId] + ".chunk.js";
};